import { Box, BoxProps, Button, Text } from '@air/zephyr';
import { useRouter } from 'next/router';
import widont from 'widont';

import { getContentfulUrl } from '~/utils/getContentfulUrl';

export interface PreviewModeBannerProps extends BoxProps {
  id?: string;
}

export const PreviewModeBanner = ({ id, tx, ...restOfProps }: PreviewModeBannerProps) => {
  const { asPath } = useRouter();
  const contentfulUrl = getContentfulUrl(id);

  return (
    <Box
      {...restOfProps}
      tx={{
        zIndex: 9999,
        position: 'fixed',
        bottom: 24,
        left: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: 4,
        maxWidth: 'calc(100% - 48px)',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.06)',
        px: 24,
        py: 12,
        color: 'white',
        pointerEvents: 'none',
        ...tx,
      }}
    >
      <Box tx={{ mr: 24 }}>
        <Text tx={{ color: 'inherit', fontWeight: 'semibold' }} variant="text-ui-14">
          Preview mode enabled
        </Text>
        <Text tx={{ color: 'inherit' }} variant="text-ui-14">
          {widont('Click the button to the right to exit.')}
        </Text>
      </Box>

      {id && (
        <Button
          as="a"
          href={contentfulUrl}
          tx={{ pointerEvents: 'initial', whiteSpace: 'nowrap', mr: 8 }}
          variant="button-outline-blue"
        >
          Edit in Contentful
        </Button>
      )}

      <Button
        as="a"
        href={`/api/preview/exit-preview?url=${asPath}`}
        tx={{ pointerEvents: 'initial', whiteSpace: 'nowrap' }}
      >
        Exit preview
      </Button>
    </Box>
  );
};
